import JobWorkflowsPage from '@/pages/jobs/workflows'
import { WorkspacePortalProvider } from '@/contexts/workspace-portal-context'

export default function EventWorkflowsPage() {
  return (
    <WorkspacePortalProvider mode="event">
      <JobWorkflowsPage />
    </WorkspacePortalProvider>
  )
}
